import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const settingsOauthCredentialsRoute: InvariantJiraRoute = {
	name: 'admin-oauth-credentials',
	path: '/secure/admin/oauth-credentials',
};
